import UltMeta, { Meta } from "./UltMeta/index";

class SpecialZone extends UltMeta {
  CDI_QICHUN = new Meta(1, "中电建蕲春");
}
export const SPECIAL_ZONE = new SpecialZone();

class State extends UltMeta {
  CONFIRMED = new Meta(1, "已确认");
  CONFIRMING = new Meta(0, "待确认");
}
export const STATE = new State();
